export default "como\nPor que\nQuantos"